import { render, staticRenderFns } from "./searchWatchActiveFilters.vue?vue&type=template&id=9056d7c6&"
import script from "./searchWatchActiveFilters.vue?vue&type=script&lang=js&"
export * from "./searchWatchActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./searchWatchActiveFilters.vue?vue&type=style&index=0&id=9056d7c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports